module.exports = __webpack_public_path__ + "static/media/ar.190b234b.svg";